// @flow
export { default } from './UserSeriesListItem';



// WEBPACK FOOTER //
// ./src/components/user/UserSeriesListItem/index.js